import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-20 sm:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/ed8c4fa39f94d7cb9d023134ab067db9.jpg"
          alt="Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-violet-900/90 via-purple-900/85 to-indigo-900/90"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Ready to Upgrade Your IT Game?
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-200 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-4">
          Join 300+ businesses that trust AZZ MATRIX for their IT needs. Get started with a free consultation and discover how we can transform your technology infrastructure.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
          <Link 
            to="/contact"
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-white text-violet-900 font-bold rounded-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer text-center"
          >
            Schedule Free Consultation
          </Link>
          <Link 
            to="/services"
            className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 border-2 border-white text-white font-bold rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer text-center"
          >
            View Pricing Plans
          </Link>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-4">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 sm:p-6">
            <i className="ri-time-line text-3xl sm:text-4xl text-violet-300 mb-2 sm:mb-3"></i>
            <h4 className="text-white font-bold text-base sm:text-lg mb-2">Fast Response</h4>
            <p className="text-gray-300 text-xs sm:text-sm">Average 15-minute response time for all support requests</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 sm:p-6">
            <i className="ri-shield-check-line text-3xl sm:text-4xl text-violet-300 mb-2 sm:mb-3"></i>
            <h4 className="text-white font-bold text-base sm:text-lg mb-2">Secure & Compliant</h4>
            <p className="text-gray-300 text-xs sm:text-sm">ISO 27001 certified with SOC 2 compliance standards</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 sm:p-6">
            <i className="ri-money-dollar-circle-line text-3xl sm:text-4xl text-violet-300 mb-2 sm:mb-3"></i>
            <h4 className="text-white font-bold text-base sm:text-lg mb-2">Flexible Pricing</h4>
            <p className="text-gray-300 text-xs sm:text-sm">Plans from $100 to $750 to fit any budget</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
